import { registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import localeFr from '@angular/common/locales/fr';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  LOCALE_ID,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';

import { authInterceptor } from './shared/services/auth.interceptor';
import { localeInterceptor } from './shared/services/locale.interceptor';
import { routes } from './app.routes';

// Angular ne ship pas les données locales par défaut depuis v9. On enregistre
// `fr` puis on l'alias en `fr-SN` (le Sénégal n'a pas de pack distinct, on
// hérite du `fr` standard — formats date / nombres identiques pour le besoin).
registerLocaleData(localeFr, 'fr-SN');
// EN pour la bascule i18n : les dates suivent la langue via le pipe `| ldate`.
registerLocaleData(localeEn, 'en');

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'fr-SN' },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    // `localeInterceptor` d'abord : il pose `Accept-Language` sur la requête
    // initiale ET sur le rejeu après refresh (authInterceptor rappelle `next`
    // avec la requête déjà clonée en amont).
    provideHttpClient(withInterceptors([localeInterceptor, authInterceptor])),
  ],
};
